import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Button, ButtonProps } from '@/components/common/Button';
import { Colors } from '@/styles/colors';
import styles from './TimeControlButton.module.scss';

interface IconTitleButtonProps extends ButtonProps {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  variant?: string;
}

export const TimeControlButton: React.FC<IconTitleButtonProps> = ({
  startIcon,
  endIcon,
  label,
  onClick,
  isDisabled = false,
  variant = 'solid',
  size = 'md',
  ...rest
}) => (
  <Button
    onClick={onClick}
    isDisabled={isDisabled}
    variant={variant}
    size={size}
    sx={{
      bg: Colors.Neutral_90,
      _hover: { bg: Colors.Neutral_80 },
      padding: '10px 12px',
      minWidth: 340,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      border: `1px solid ${Colors.Neutral_50}`,
      borderBottom: 'none',
    }}
    {...rest}
  >
    <Flex w="100%" align="center" justify="space-between" gap={2}>
      <Box>{startIcon}</Box>
      <Box flex="1" textAlign="center" className={styles.label}>
        {label}
      </Box>
      <Box>{endIcon}</Box>
    </Flex>
  </Button>
);
export default TimeControlButton;
